/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Diff_OldInputs */

const cs_ebr_diff_old = /** @type {(inputs: Ebr_Diff_OldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyní v CRM`)
};

const en_ebr_diff_old = /** @type {(inputs: Ebr_Diff_OldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Now in CRM`)
};

/**
* | output |
* | --- |
* | "Now in CRM" |
*
* @param {Ebr_Diff_OldInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_diff_old = /** @type {((inputs?: Ebr_Diff_OldInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Diff_OldInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_diff_old(inputs)
	return cs_ebr_diff_old(inputs)
});